"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldPropsEnum = void 0;
var FieldPropsEnum;
(function (FieldPropsEnum) {
    FieldPropsEnum["id"] = "id";
    FieldPropsEnum["path"] = "path";
    FieldPropsEnum["name"] = "name";
    FieldPropsEnum["type"] = "type";
    FieldPropsEnum["value"] = "value";
    FieldPropsEnum["initial"] = "initial";
    FieldPropsEnum["default"] = "default";
    FieldPropsEnum["checked"] = "checked";
    FieldPropsEnum["label"] = "label";
    FieldPropsEnum["placeholder"] = "placeholder";
    FieldPropsEnum["related"] = "related";
    FieldPropsEnum["options"] = "options";
    FieldPropsEnum["extra"] = "extra";
    FieldPropsEnum["bindings"] = "bindings";
    FieldPropsEnum["hooks"] = "hooks";
    FieldPropsEnum["handlers"] = "handlers";
    FieldPropsEnum["error"] = "error";
    // computed
    FieldPropsEnum["disabled"] = "disabled";
    FieldPropsEnum["deleted"] = "deleted";
    FieldPropsEnum["blurred"] = "blurred";
    FieldPropsEnum["clearing"] = "clearing";
    FieldPropsEnum["resetting"] = "resetting";
    FieldPropsEnum["changed"] = "changed";
    FieldPropsEnum["touched"] = "touched";
    FieldPropsEnum["focused"] = "focused";
    FieldPropsEnum["isEmpty"] = "isEmpty";
    FieldPropsEnum["isDefault"] = "isDefault";
    FieldPropsEnum["isPristine"] = "isPristine";
    FieldPropsEnum["isDirty"] = "isDirty";
    FieldPropsEnum["isValid"] = "isValid";
    FieldPropsEnum["hasError"] = "hasError";
    // handlers
    FieldPropsEnum["onInit"] = "onInit";
    FieldPropsEnum["onChange"] = "onChange";
    FieldPropsEnum["onBlur"] = "onBlur";
    FieldPropsEnum["onFocus"] = "onFocus";
    FieldPropsEnum["onToggle"] = "onToggle";
    FieldPropsEnum["onDrop"] = "onDrop";
    FieldPropsEnum["onSubmit"] = "onSubmit";
    FieldPropsEnum["onReset"] = "onReset";
    FieldPropsEnum["onClear"] = "onClear";
    FieldPropsEnum["onAdd"] = "onAdd";
    FieldPropsEnum["onDel"] = "onDel";
    FieldPropsEnum["autoFocus"] = "autoFocus";
    FieldPropsEnum["onKeyDown"] = "onKeyDown";
    FieldPropsEnum["onKeyUp"] = "onKeyUp";
})(FieldPropsEnum = exports.FieldPropsEnum || (exports.FieldPropsEnum = {}));
//# sourceMappingURL=FieldProps.js.map